/* Onewheelers store (25/10/2026): product page, cart drawer, countdowns,
 * early access, Klaviyo signup and popup. Config comes from window.OW (layout/theme.liquid). */
(() => {
  const C = window.OW || {};
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || C.root || '/';
  const $ = (q, r = document) => r.querySelector(q);
  const $$ = (q, r = document) => [...r.querySelectorAll(q)];
  const T = C.t || {};
  // tr('only_left', { count: 3 }) -> locale string with {{ count }} filled in
  const tr = (k, vars) => String(T[k] == null ? k : T[k]).replace(/\{\{\s*(\w+)\s*\}\}/g, (m, v) => (vars && vars[v] != null ? vars[v] : ''));
  const DAYS = (T.days_list || 'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday').split(',');
  const fmt = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: C.currency || 'EUR' });
  const money = (cents) => fmt.format(cents / 100).replace(/\s/g, '').replace(/,00$/, '');
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ts = (iso) => { const t = Date.parse(iso || ''); return Number.isNaN(t) ? null : t; };

  /* ---------- early access ---------- */
  const qs = new URLSearchParams(location.search);
  if (C.eaCode && qs.get('ea') === C.eaCode) store.set('ow_ea', '1');
  const hasEA = () => store.get('ow_ea') === '1';
  const opensAt = (dropAt) => (dropAt == null ? null : hasEA() ? dropAt - (Number(C.eaMinutes) || 0) * 60000 : dropAt);

  /* ---------- delivery date ---------- */
  function etaDate() {
    const d = new Date();
    d.setDate(d.getDate() + (Number(C.days) || 2));
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return DAYS[d.getDay()] + ' ' + d.getDate() + '/' + (d.getMonth() + 1);
  }
  function renderEta() {
    $$('[data-ow-eta]').forEach((el) => {
      el.innerHTML = '<span class="ow-okdot"></span>' + esc(C.promiseLine || T.promise_line || '') + ', ' + tr('eta_html', { date: etaDate() });
    });
  }

  /* ---------- drawers ---------- */
  const scrim = $('[data-ow-scrim]');
  function openDrawer(el) {
    if (!el) return;
    closeDrawers();
    el.classList.add('is-on');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-on');
    document.body.classList.add('ow-lock');
    setTimeout(() => el.focus({ preventScroll: true }), 60);
  }
  function closeDrawers() {
    $$('[data-ow-drawer].is-on').forEach((d) => { d.classList.remove('is-on'); d.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('is-on');
    document.body.classList.remove('ow-lock');
  }
  if (scrim) scrim.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawers(); closePopup(); } });

  /* ---------- cart ---------- */
  const cartEl = $('#ow-cart');
  let upsell = [];
  try { upsell = JSON.parse(($('#ow-upsell') || {}).textContent || '[]'); } catch (e) { upsell = []; }

  async function getCart() {
    const r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function addToCart(id, quantity = 1) {
    const r = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || tr('cap_error'));
    trackAdded(j.items && j.items[0]);
    return j;
  }
  // Tell Klaviyo (only for visitors it already knows) so the cart flow can follow up on carts that never reach checkout.
  function trackAdded(item) {
    try {
      if (!window.klaviyo || !item) return;
      const price = (item.final_price || item.price) / 100;
      window.klaviyo.push(['track', 'Added to Cart', {
        $value: price * (item.quantity || 1),
        AddedItemProductName: item.product_title,
        AddedItemProductID: item.product_id,
        AddedItemVariant: item.variant_title,
        AddedItemPrice: price,
        AddedItemQuantity: item.quantity,
        AddedItemImageURL: item.image,
        AddedItemURL: location.origin + item.url,
        CheckoutURL: location.origin + '/cart',
      }]);
    } catch (e) {}
  }
  function cartNote(msg) {
    if (!cartEl || !msg) return;
    let n = $('[data-ow-cart-note]', cartEl);
    if (!n) {
      n = document.createElement('p');
      n.className = 'ow-cart-note';
      n.setAttribute('data-ow-cart-note', '');
      n.setAttribute('role', 'status');
      const lines = $('[data-ow-lines]', cartEl);
      if (lines) lines.before(n);
    }
    n.textContent = msg;
    n.hidden = false;
    clearTimeout(n._t);
    n._t = setTimeout(() => { n.hidden = true; }, 4500);
  }
  async function changeLine(key, quantity) {
    const r = await fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || !Array.isArray(j.items)) {
      // e.g. 422 "Only 1 item was added to your cart due to availability": keep the cart as it is and say why
      cartNote(j.description || j.message || tr('cap_error'));
      return getCart();
    }
    return j;
  }
  function updateBubble(count) {
    const icon = $('#cart-icon-bubble');
    if (!icon) return;
    let b = $('.cart-count-bubble', icon);
    if (!count) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; icon.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + esc(tr('cart_title', { count })) + '</span>';
  }
  function renderCart(cart) {
    if (!cartEl) return;
    const free = (Number(C.free) || 150) * 100;
    const total = cart.total_price;
    const left = Math.max(0, free - total);
    const pct = Math.min(100, (total / free) * 100);
    $('[data-ow-cart-title]', cartEl).textContent = tr('cart_title', { count: cart.item_count });
    updateBubble(cart.item_count);

    $('[data-ow-ship]', cartEl).innerHTML = cart.item_count ? (
      '<div class="ow-ship"><div class="ow-ship__msg">' +
      (left > 0 ? tr('left_html', { amount: money(left) }) : tr('free_html')) +
      '</div><div class="ow-ship__bar' + (left > 0 ? '' : ' is-full') + '"><i style="width:' + pct + '%"></i></div>' +
      '<div class="ow-ship__fast"><span class="ow-okdot"></span>' + esc(tr('fast', { date: etaDate() })) + '</div></div>'
    ) : '';

    $('[data-ow-lines]', cartEl).innerHTML = cart.items.length ? cart.items.map((it) => {
      const img = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.includes('?') ? '&' : '?') + 'width=200' : '';
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
      const was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      const disc = (it.line_level_discount_allocations || []).map((d) => esc(d.discount_application.title)).join(', ');
      return '<div class="ow-line">' +
        (img ? '<a href="' + esc(it.url) + '"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' : '<span></span>') +
        '<div><a class="ow-line__n" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="ow-line__v">' + variant + money(it.final_price) + '</div>' +
        (disc ? '<div class="ow-line__d">' + disc + '</div>' : '<div class="ow-line__d">● ' + esc(tr('in_stock')) + '</div>') +
        '<div><span class="ow-qty"><button type="button" data-ow-q="' + esc(it.key) + '" data-n="' + (it.quantity - 1) + '" aria-label="' + esc(tr('less')) + '">−</button><span>' + it.quantity + '</span><button type="button" data-ow-q="' + esc(it.key) + '" data-n="' + (it.quantity + 1) + '" aria-label="' + esc(tr('more')) + '">+</button></span>' +
        '<button type="button" class="ow-line__rm" data-ow-q="' + esc(it.key) + '" data-n="0">' + esc(tr('remove')) + '</button></div></div>' +
        '<div class="ow-line__p">' + was + money(it.final_line_price) + '</div></div>';
    }).join('') : '<div class="ow-empty">' + esc(tr('cart_empty')) + '<br><br><button type="button" class="ow-btn ow-btn--ghost" data-ow-close>' + esc(tr('keep_shopping')) + '</button></div>';

    let bundle = '';
    if (C.bundle && C.bundle.on && cart.items.length) {
      const hs = (C.bundle.handles || []).map((h) => h.trim());
      const n = cart.items.filter((i) => hs.includes(i.handle)).reduce((a, i) => a + i.quantity, 0);
      if (n === 1) bundle = '<div class="ow-bundle">' + tr('bundle_one_html', { price: money((Number(C.bundle.price) || 120) * 100) }) + '</div>';
      if (n >= 2 && cart.total_discount > 0) bundle = '<div class="ow-bundle is-ok">' + tr('bundle_ok_html', { label: esc(C.bundle.label || ''), amount: money(cart.total_discount) }) + '</div>';
    }
    $('[data-ow-bundle]', cartEl).innerHTML = bundle;

    const inCart = new Set(cart.items.map((i) => i.handle));
    const ups = upsell.filter((u) => u.available && !inCart.has(u.handle)).slice(0, 3);
    $('[data-ow-ups]', cartEl).innerHTML = cart.items.length && ups.length ? (
      '<h4>' + esc(left > 0 && left < 4000 ? tr('ups_free') : tr('ups_more')) + '</h4><div class="ow-ups__row">' +
      ups.map((u) => '<div class="ow-up">' + (u.img ? '<img src="' + esc(u.img) + '" alt="" loading="lazy">' : '') +
        '<div class="ow-up__t"><div class="ow-up__n">' + esc(u.title) + '</div><div class="ow-up__b"><span>' + money(u.price) + '</span>' +
        '<button type="button" data-ow-add-id="' + u.id + '" aria-label="' + esc(tr('add_item', { title: u.title })) + '">+</button></div></div></div>').join('') + '</div>'
    ) : '';

    const discLine = cart.total_discount > 0 ? '<div class="ow-tot ow-tot--disc"><span>' + esc(tr('discount')) + '</span><b>−' + money(cart.total_discount) + '</b></div>' : '';
    $('[data-ow-totals]', cartEl).innerHTML = cart.item_count ? (
      discLine + '<div class="ow-tot"><span>' + esc(tr('subtotal')) + '</span><b>' + money(total) + '</b></div>' +
      '<p class="ow-small">' + (left > 0 ? esc(tr('shipping_calc', { amount: money(free) })) : tr('shipping_free_html')) + '</p>'
    ) : '';
    $$('[data-ow-checkout]', cartEl).forEach((b) => { b.disabled = !cart.item_count; });
    const dyn = $('.additional-checkout-buttons', cartEl);
    if (dyn) dyn.style.display = cart.item_count ? '' : 'none';
  }
  async function openCart() {
    if (!cartEl) { location.href = ROOT + 'cart'; return; }
    openDrawer(cartEl);
    try { renderCart(await getCart()); } catch (e) { /* keep previous render */ }
  }
  window.OWCart = { open: openCart, add: addToCart, refresh: async () => renderCart(await getCart()) };

  document.addEventListener('click', async (e) => {
    const icon = e.target.closest('#cart-icon-bubble');
    if (icon && cartEl) { e.preventDefault(); openCart(); return; }
    const close = e.target.closest('[data-ow-close]');
    if (close) { closeDrawers(); return; }
    const q = e.target.closest('[data-ow-q]');
    if (q) { q.disabled = true; renderCart(await changeLine(q.dataset.owQ, Number(q.dataset.n))); return; }
    const up = e.target.closest('[data-ow-add-id]');
    if (up) {
      up.disabled = true;
      let ok = true;
      try { await addToCart(up.dataset.owAddId); } catch (err) { ok = false; }
      if (up.classList.contains('ow-chip')) {
        up.disabled = false;
        if (ok) { up.classList.add('is-added'); setTimeout(() => up.classList.remove('is-added'), 1500); }
        if (ok) { await openCart(); return; }
      }
      renderCart(await getCart());
      return;
    }
    const opener = e.target.closest('[data-ow-open]');
    if (opener) { openDrawer(document.getElementById(opener.dataset.owOpen)); }
  });

  /* ---------- countdowns ---------- */
  function tickCountdowns() {
    const now = Date.now();
    $$('[data-ow-cd]').forEach((el) => {
      const t = ts(el.dataset.owCd);
      if (t == null) return;
      let s = Math.max(0, Math.floor((t - now) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      const set = (u, v) => { const b = $('[data-u="' + u + '"]', el); if (b) b.textContent = u === 'd' ? v : String(v).padStart(2, '0'); };
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
    $$('[data-ow-dropbadge]').forEach((el) => {
      const t = ts(el.dataset.dropAt);
      el.hidden = t != null && now >= t;
    });
    $$('[data-ow-ea]').forEach((el) => {
      const t = ts(el.dataset.dropAt);
      el.classList.toggle('is-live', t != null && now >= t);
    });
  }

  /* ---------- product page ---------- */
  function initPdp(root) {
    const dataEl = $('[data-ow-product]', root);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const opts = $$('[data-ow-opt]', root);
    const sel = new Array(data.options.length).fill(null);
    const addBtn = $('[data-ow-add]', root);
    const buy = $('[data-ow-buy]', root);
    const bis = $('[data-ow-bis]', root);
    const pre = $('[data-ow-predrop]', root);
    const priceEl = $('[data-ow-price]', root);
    const wasEl = $('[data-ow-was]', root);
    const idInput = $('[data-ow-id]', root);
    const sticky = $('[data-ow-sticky]', root);
    const stickyBtn = $('[data-ow-sticky-btn]', root);
    const stickyTxt = $('[data-ow-sticky-txt]', root);
    const track = $('[data-ow-track]', root);
    const slides = track ? $$('.ow-gal__slide', track) : [];
    const hasOptions = opts.length > 0;
    const last = opts.length - 1;

    const urlV = qs.get('variant');
    const pv = urlV ? data.variants.find((v) => String(v.id) === urlV) : null;
    if (pv) pv.options.forEach((o, i) => { sel[i] = o; });
    opts.forEach((o, i) => { const b = $$('.ow-sz', o); if (b.length === 1) sel[i] = b[0].dataset.value; });
    if (!pv && data.options.length > 1) {
      const cur = data.variants.find((v) => v.id === data.currentId);
      if (cur) cur.options.slice(0, -1).forEach((o, i) => { sel[i] = o; });
    }

    const find = (s) => (s.some((x) => x === null) ? null : data.variants.find((v) => v.options.every((o, i) => o === s[i])) || null);
    const stockLabel = (v) => {
      if (!v) return { t: '' };
      if (!v.available) return { t: tr('sold_out'), out: true };
      if (v.qty !== null && v.qty > 0 && v.qty <= (Number(C.lowStock) || 5)) return { t: v.qty === 1 ? tr('last_one') : tr('only_left', { count: v.qty }), low: true };
      return { t: tr('in_stock') };
    };

    let predrop = false;
    const dropAt = root.dataset.drop === 'true' ? ts(root.dataset.dropAt) : null;
    function checkDrop() {
      const open = opensAt(dropAt);
      const was = predrop;
      predrop = open != null && Date.now() < open;
      if (pre) pre.classList.toggle('ow-hide', !predrop);
      if (buy) buy.classList.toggle('ow-hide', predrop);
      if (was !== predrop) render();
    }

    function render() {
      opts.forEach((o, i) => {
        $$('.ow-sz', o).forEach((b) => {
          const val = b.dataset.value;
          b.classList.toggle('is-on', sel[i] === val);
          const sm = $('small', b);
          if (i === last && predrop) {
            if (sm) sm.textContent = '';
            b.classList.remove('is-out');
          } else if (i === last) {
            const test = sel.slice(); test[i] = val;
            const v = find(test);
            const L = stockLabel(v);
            if (sm) { sm.textContent = L.t; sm.classList.toggle('is-low', !!L.low); }
            b.classList.toggle('is-out', !!L.out);
          } else if (sm) sm.textContent = '';
        });
      });
      const v = hasOptions ? find(sel) : data.variants[0];
      const shown = v || data.variants.find((x) => x.id === data.currentId) || data.variants[0];
      if (priceEl) priceEl.textContent = money(shown.price);
      if (wasEl) { wasEl.textContent = money(shown.compare); wasEl.classList.toggle('ow-hide', !(shown.compare > shown.price)); }
      if (v && idInput) idInput.value = v.id;
      if (buy) buy.classList.toggle('is-nosel', !v);
      const size = sel[last] || '';
      if (predrop) {
        if (stickyBtn) stickyBtn.textContent = tr('early_access');
        if (stickyTxt) stickyTxt.textContent = tr('drop', { label: C.dropLabel || '' });
      } else if (!v) {
        const gc = root.classList.contains('ow-pdp--gc');
        addBtn.disabled = true; addBtn.textContent = tr(gc ? 'choose_amount' : 'choose_size');
        if (stickyBtn) stickyBtn.textContent = tr(gc ? 'choose_amount_short' : 'choose_size_short');
        if (stickyTxt) stickyTxt.textContent = money(shown.price) + ' · ' + tr(gc ? 'choose_amount' : 'choose_size');
      } else if (!v.available) {
        addBtn.disabled = true; addBtn.textContent = tr('sold_out');
        if (stickyBtn) stickyBtn.textContent = tr('sold_out');
        if (stickyTxt) stickyTxt.textContent = money(v.price) + (size ? ' · ' + size : '');
      } else {
        addBtn.disabled = false; addBtn.textContent = tr('add_to_cart_price', { price: money(v.price) });
        if (stickyBtn) stickyBtn.textContent = tr('add_to_cart');
        if (stickyTxt) stickyTxt.textContent = money(v.price) + (size ? ' · ' + size : '');
      }
      $$('tr[data-size]', root).forEach((tr) => tr.classList.toggle('is-on', tr.dataset.size === size));
      // Sold-out size: offer a back-in-stock mail instead of a dead button
      if (bis) {
        const out = !predrop && !!v && !v.available;
        bis.hidden = !out;
        if (out && bis.dataset.variant !== String(v.id)) {
          bis.dataset.variant = v.id;
          bis.dataset.size = size;
          $('[data-ow-bis-t]', bis).textContent = tr('bis_title', { size });
          bis.classList.remove('is-done');
          $('.ow-bis__msg', bis).hidden = true;
        }
      }
    }

    function nudgeSizes() {
      const box = opts[last] || opts[0];
      if (!box) return;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 280 });
    }

    async function add() {
      if (predrop) { (pre || root).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      const v = hasOptions ? find(sel) : data.variants[0];
      if (!v) { nudgeSizes(); return; }
      if (!v.available) return;
      addBtn.classList.add('is-loading');
      try {
        await addToCart(v.id, 1);
        await openCart();
      } catch (err) {
        addBtn.textContent = err.message;
        setTimeout(render, 2500);
      } finally {
        addBtn.classList.remove('is-loading');
      }
    }

    root.addEventListener('click', (e) => {
      const b = e.target.closest('.ow-sz');
      if (b) {
        const i = opts.indexOf(b.closest('[data-ow-opt]'));
        sel[i] = b.dataset.value;
        render();
        if (i !== last) {
          const v = data.variants.find((x) => x.options[i] === sel[i] && x.media);
          if (v && track) {
            const idx = slides.findIndex((s) => s.dataset.mediaId === String(v.media));
            if (idx > -1) track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
          }
        }
        return;
      }
      if (e.target.closest('[data-ow-add]')) { add(); return; }
      if (e.target.closest('[data-ow-sticky-btn]')) { add(); return; }
      const t = e.target.closest('[data-thumb]');
      if (t && track) track.scrollTo({ left: track.clientWidth * Number(t.dataset.thumb), behavior: 'smooth' });
      const u = e.target.closest('[data-unit]');
      if (u) {
        $$('[data-unit]', root).forEach((x) => x.classList.toggle('is-on', x.dataset.unit === u.dataset.unit));
        $$('td[data-cm]', root).forEach((td) => {
          const n = parseFloat(String(td.dataset.cm).replace(',', '.'));
          td.textContent = u.dataset.unit === 'in' && !Number.isNaN(n) ? (n / 2.54).toFixed(1).replace('.', ',') : td.dataset.cm;
        });
      }
    });

    const thumbsEl = $('[data-ow-thumbs]', root);
    const countEl = $('[data-ow-gcount]', root);
    if (slides.length > 1) {
      if (thumbsEl) thumbsEl.innerHTML = slides.map((sl, i) => '<button type="button" class="' + (i ? '' : 'is-on') + '" data-thumb="' + i + '" aria-label="' + esc(tr('photo', { n: i + 1 })) + '"><img src="' + esc(sl.dataset.thumbSrc || '') + '" alt="" loading="lazy"></button>').join('');
      if (countEl) countEl.textContent = '1 / ' + slides.length;
    } else {
      if (thumbsEl) thumbsEl.remove();
      if (countEl) countEl.remove();
    }
    if (track && slides.length > 1) {
      const count = countEl;
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        $$('[data-thumb]', root).forEach((b, j) => b.classList.toggle('is-on', i === j));
      }, { passive: true });
    }
    $$('video', root).forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); v.play().catch(() => {}); });

    const deal = $('[data-ow-deal]', root);
    if (deal) {
      const f = ts(root.dataset.dealFrom); const u = ts(root.dataset.dealUntil); const n = Date.now();
      deal.classList.toggle('ow-hide', !((f == null || n >= f) && (u == null || n < u)));
    }

    if (sticky) {
      const onScroll = () => {
        const anchor = predrop ? pre : addBtn;
        const r = anchor ? anchor.getBoundingClientRect() : null;
        sticky.classList.toggle('is-on', !!r && r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    checkDrop();
    render();
    if (dropAt != null) setInterval(checkDrop, 1000);

    // Sold-out sizes update while the page is open (drop days move fast).
    setInterval(async () => {
      if (document.hidden) return;
      try {
        const r = await fetch(ROOT + 'products/' + data.handle + '.js', { headers: { Accept: 'application/json' } });
        const pj = await r.json();
        let changed = false;
        pj.variants.forEach((nv) => {
          const v = data.variants.find((x) => x.id === nv.id);
          if (v && v.available !== nv.available) { v.available = nv.available; if (!nv.available) v.qty = 0; changed = true; }
        });
        if (changed) render();
      } catch (e) { /* offline: keep current state */ }
    }, 45000);
  }

  /* ---------- Back in stock (Klaviyo mails when the size is back) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ow-bis]');
    if (!form) return;
    e.preventDefault();
    const input = $('input[type="email"]', form);
    const btn = $('button[type="submit"]', form);
    const msg = $('.ow-bis__msg', form);
    const show = (t, err) => { msg.hidden = false; msg.textContent = t; msg.classList.toggle('is-err', !!err); };
    const email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { show(tr('cap_invalid'), true); input.focus(); return; }
    btn.classList.add('is-loading');
    try {
      const r = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(C.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email } } } },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.dataset.variant } } },
          },
        }),
      });
      if (!(r.status >= 200 && r.status < 300)) throw new Error('Klaviyo ' + r.status);
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email });
      form.classList.add('is-done');
      show(tr('bis_ok', { size: form.dataset.size || '' }));
    } catch (err) {
      show(tr('cap_error'), true);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- Klaviyo signup ---------- */
  async function subscribe(email, source) {
    const r = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(C.klaviyoKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Site · ' + source,
            profile: { data: { type: 'profile', attributes: { email, properties: { early_access: true, signup_source: source, signup_page: location.pathname } } } },
          },
          relationships: { list: { data: { type: 'list', id: C.klaviyoList } } },
        },
      }),
    });
    if (!(r.status >= 200 && r.status < 300)) throw new Error('Klaviyo ' + r.status);
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ow-capture]');
    if (!form) return;
    e.preventDefault();
    const msg = $('.ow-cap__msg', form);
    const input = $('input[type="email"]', form);
    const btn = $('button[type="submit"]', form);
    const show = (t, err) => { msg.hidden = false; msg.textContent = t; msg.classList.toggle('is-err', !!err); };
    if ($('input[name="website"]', form).value) return;
    const email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { show(tr('cap_invalid'), true); input.focus(); return; }
    btn.classList.add('is-loading');
    try {
      await subscribe(email, form.dataset.source || 'Site');
      store.set('ow_sub', '1');
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email });
      form.classList.add('is-done');
      show(($('template[data-ok]', form) || {}).innerHTML || tr('cap_success'));
      if (form.closest('[data-ow-pop]')) setTimeout(closePopup, 2600);
    } catch (err) {
      show(tr('cap_error'), true);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- popup (+ floating "Get early access" teaser; any [data-ow-pop-open] opens it) ---------- */
  const pop = $('[data-ow-pop]');
  const teaser = $('[data-ow-teaser]');
  const subscribed = () => store.get('ow_sub') === '1';
  function showTeaser() {
    if (!teaser || subscribed() || (pop && pop.classList.contains('is-on'))) return;
    if (Date.now() - (Number(store.get('ow_teaser_x')) || 0) < 86400000) return;
    teaser.hidden = false;
  }
  function openPopup() {
    if (!pop) return;
    pop.classList.add('is-on');
    pop.setAttribute('aria-hidden', 'false');
    if (teaser) teaser.hidden = true;
  }
  function closePopup() {
    if (!pop || !pop.classList.contains('is-on')) return;
    pop.classList.remove('is-on');
    pop.setAttribute('aria-hidden', 'true');
    store.set('ow_pop_closed', String(Date.now()));
    setTimeout(showTeaser, 600);
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-ow-pop-open]');
    if (o && pop) { e.preventDefault(); openPopup(); return; }
    if (e.target.closest('[data-ow-teaser-x]')) { teaser.hidden = true; store.set('ow_teaser_x', String(Date.now())); }
  });
  if (pop) {
    const days = Number(pop.dataset.days) || 7;
    const closedAt = Number(store.get('ow_pop_closed')) || 0;
    const checkout = /\/checkouts?\//.test(location.pathname);
    const timedBlocked = subscribed() || checkout || Date.now() - closedAt < days * 86400000;
    const delay = (Number(pop.dataset.delay) || 6) * 1000;
    // the popup shows whether or not the cookie banner was answered, and sits above it (Keanu 2/11: "altijd")
    let shown = false;
    const tryShow = (exit) => {
      if (shown || subscribed()) return;
      if (exit) {
        // leaving the site: one more chance per visit, even if the timed popup was closed before
        let seen = null; try { seen = sessionStorage.getItem('ow_pop_exit'); } catch (e) {}
        if (seen) return;
        try { sessionStorage.setItem('ow_pop_exit', '1'); } catch (e) {}
      } else if ($('[data-ow-drawer].is-on')) { setTimeout(() => tryShow(false), 4000); return; }
      shown = true;
      openPopup();
    };
    if (!timedBlocked) setTimeout(() => tryShow(false), delay);
    else if (!subscribed() && !checkout) setTimeout(showTeaser, delay);
    if (pop.dataset.exit === 'true' && !checkout) {
      // desktop: mouse leaves through the top of the window (tabs, address bar, close)
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) tryShow(true); });
      // mobile: a fast swipe back up after reading = reaching for the address bar / leaving
      let lastY = window.scrollY, lastT = Date.now(), maxY = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY, t = Date.now();
        maxY = Math.max(maxY, y);
        const speed = (lastY - y) / Math.max(1, t - lastT);
        if (maxY > window.innerHeight && speed > 1.6) tryShow(true);
        lastY = y; lastT = t;
      }, { passive: true });
      // mobile: back on the tab after switching away (another app/tab), 20 s+ into the visit
      const t0 = Date.now();
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && Date.now() - t0 > 20000) tryShow(true); });
    }
    pop.addEventListener('click', (e) => { if (e.target === pop || e.target.closest('[data-ow-pop-close]')) closePopup(); });
  }

  /* ---------- hero states ---------- */
  function tickHero() {
    const now = Date.now();
    $$('[data-ow-hero]').forEach((h) => {
      const f = ts(h.dataset.dealFrom), u = ts(h.dataset.dealUntil), d = ts(h.dataset.dropAt);
      let st = 'live';
      if (f != null && now < f) st = 'pre-deal';
      else if (f != null && u != null && now < u) st = 'deal';
      else if (d != null && now < d) st = 'pre-drop';
      if (h.dataset.state !== st) {
        h.dataset.state = st;
        $$('.ow-hero__st', h).forEach((el) => el.classList.toggle('is-on', el.dataset.st === st));
        const ea = $('[data-ow-hero-ea]', h);
        if (ea) ea.style.display = st === 'deal' || st === 'live' ? 'none' : '';
      }
    });
  }

  /* ---------- lazy videos (play only when visible) ---------- */
  if ('IntersectionObserver' in window) {
    const start = (v) => {
      if (!v.src && v.dataset.src) v.src = (window.innerWidth < 750 && v.dataset.srcM) || v.dataset.src;
      v.preload = 'auto'; v.muted = true; v.play().catch(() => {});
    };
    const vio = new IntersectionObserver((ents) => ents.forEach((en) => {
      const v = en.target;
      if (!en.isIntersecting) { v.pause(); return; }
      if (document.readyState === 'complete') start(v); else window.addEventListener('load', () => start(v), { once: true });
    }), { rootMargin: '200px' });
    $$('video[data-ow-lazyvid], .ow-hero__vid').forEach((v) => vio.observe(v));
  }

  /* ---------- lights on ---------- */
  $$('[data-ow-lights]').forEach((sec) => {
    const btn = $('[data-ow-lights-btn]', sec), tag = $('[data-ow-lights-tag]', sec);
    const set = (on) => {
      sec.classList.toggle('is-on', on);
      if (btn) btn.setAttribute('aria-pressed', String(on));
      if (tag) tag.textContent = on ? 'In je koplampen' : 'Overdag';
      $('.ow-switch__l', sec).textContent = on ? 'Licht uit' : 'Licht aan';
    };
    if (btn) btn.addEventListener('click', () => set(!sec.classList.contains('is-on')));
    $('[data-ow-lights-stage]', sec).addEventListener('click', () => set(!sec.classList.contains('is-on')));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => {
        if (en.isIntersecting) { setTimeout(() => set(true), 700); io.disconnect(); }
      }), { threshold: 0.6 });
      io.observe(sec);
    }
  });

  /* ---------- announcement bar ---------- */
  $$('[data-ow-ann]').forEach((bar) => {
    const msgs = $$('.ow-ann__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 3800);
  });

  /* ---------- testimonials: endless belt, animated in CSS (smooth on iPhone); pauses on hover/touch ---------- */
  function initTm(track) {
    if (track.dataset.owTmOn) return;
    track.dataset.owTmOn = '1';
    const cards = $$('.ow-tm__card', track);
    if (cards.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // stays a swipeable row
    const belt = document.createElement('div');
    belt.className = 'ow-tm__belt';
    cards.forEach((c) => belt.appendChild(c));
    cards.forEach((c) => {
      const k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.removeAttribute('data-shopify-editor-block');
      $$('a', k).forEach((a) => { a.tabIndex = -1; });
      belt.appendChild(k);
    });
    belt.style.setProperty('--ow-belt-dur', (cards.length * 9) + 's');
    track.appendChild(belt);
    track.classList.add('is-belt');
    let t;
    const hold = () => { clearTimeout(t); belt.classList.add('is-held'); };
    const release = (ms) => { clearTimeout(t); t = setTimeout(() => belt.classList.remove('is-held'), ms); };
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('touchend', () => release(1500), { passive: true });
    track.addEventListener('focusin', hold);
    track.addEventListener('focusout', () => release(300));
  }

  /* ---------- language: a Dutch-speaking browser lands on the Dutch site once; a manual choice always wins ---------- */
  (function () {
    const form = document.getElementById('OwLangForm');
    if (!form) return; // only rendered when more than one language is published on this domain
    let chosen = null;
    try { chosen = localStorage.getItem('ow_lang'); } catch (e) {}
    form.addEventListener('submit', (e) => {
      const b = e.submitter;
      try { localStorage.setItem('ow_lang', (b && b.value) || 'manual'); } catch (er) {}
    });
    if (chosen) return;
    const cur = (document.documentElement.lang || '').slice(0, 2);
    const wantsNl = (navigator.languages || [navigator.language || '']).slice(0, 2).some((l) => /^nl\b/i.test(l));
    const nl = form.querySelector('button[value^="nl"]');
    if (cur === 'en' && wantsNl && nl && !navigator.webdriver) nl.click();
  })();

  /* ---------- collection intro: "read more" on phones ---------- */
  $$('.collection-hero__description').forEach((d) => {
    if (window.innerWidth >= 750 || d.scrollHeight < 190) return;
    d.classList.add('ow-clamp');
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'ow-more';
    b.textContent = T.read_more || 'Read more';
    b.addEventListener('click', () => { d.classList.remove('ow-clamp'); b.remove(); });
    d.after(b);
  });

  /* ---------- boot ---------- */
  $$('[data-ow-pdp]').forEach(initPdp);
  $$('[data-ow-tm]').forEach(initTm);
  renderEta();
  tickCountdowns();
  tickHero();
  setInterval(() => { tickCountdowns(); tickHero(); }, 1000);
  document.addEventListener('shopify:section:load', (e) => { $$('[data-ow-pdp]', e.target).forEach(initPdp); $$('[data-ow-tm]', e.target).forEach(initTm); renderEta(); });
})();
